import styled from 'styled-components';
import bglogin from 'assets/img/bglogin.jpg';
import { colors, fonts } from 'stylesheets';
import { Link } from 'react-router-dom';
import { Button } from 'triider-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: url(${bglogin}) no-repeat center;
  background-size: cover;
  display: flex;
  align-items: center;
`;

export const BoxLogin = styled.div`
  width: 512px;
  min-height: 442px;
  height: auto;
  background: ${colors.white};
  border-radius: 3px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin: 0 auto;
  padding: 50px 55px;
  h1 {
    font-family: ${fonts.secondary};
    text-transform: uppercase;
    font-size: 24px;
  }
  & > div {
    margin-top: 30px;
  }
`;

export const StyledButtonTriider = styled(Button)`
  height: 44px;
  font: ${fonts.secundary};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

export const StyledLink = styled(Link)`
  font-family: ${fonts.primary};
  font-weight: 500;
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
  text-decoration: none;
  margin-bottom: 27px;
  margin-top: 10px;
  color: ${colors.primary};
  text-transform: uppercase;
  &:hover {
    text-decoration: none;
    color: ${colors.primary};
  }
`;
